import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import EcrionForm from '../../../EcrionForms/EcrionForm';
import { FormContextProvider } from '../../../EcrionForms/context/FormContext';
import useResizeObserver from '../useResizeObserver';
import Utils from '../../../../../utils';
var RunFormFrame = React.forwardRef(
/**
 * @param {import('./types').RunFormFrameProps & import('../../../EcrionForms/types').EcrionFormProps} props
 * @param {React.Ref<import('../../../EcrionForms/api/types').EcrionFormApi>} ref
 */
function (props, ref) {
  var xsSize = props.xsSize,
      hidden = props.hidden,
      formResized = props.formResized,
      rest = _objectWithoutProperties(props, ["xsSize", "hidden", "formResized"]);

  var setObserver = useResizeObserver(formResized);
  return React.createElement(Grid, {
    item: true,
    xs: xsSize,
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "stretch",
    style: {
      height: '100%',
      overflow: 'auto',
      width: hidden ? 0 : '100%'
    }
  }, React.createElement(Grid, {
    ref: setObserver,
    item: true,
    xs: true,
    style: {
      maxWidth: 900,
      width: '100%',
      overflow: 'auto'
    }
  }, React.createElement(FormContextProvider, {
    reducers: []
  }, React.createElement(EcrionForm, Object.assign({
    ref: ref
  }, rest)))));
});
export default React.memo(RunFormFrame, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});